import React from 'react'
import { __ } from '../lib/helpers'

const propTypes = {
  showForm: React.PropTypes.string.isRequired,
  setShowForm: React.PropTypes.func.isRequired,
}

class IndieButton extends React.Component {

  constructor(props) {
    super(props)

    this.handleButtonClick = this.handleButtonClick.bind(this)
  }
	
  handleButtonClick(event) {
	this.props.setShowForm(true)
  }

  render() {
    return (
      <a className="IndieButton" ref="btn" onClick={this.handleButtonClick}>
        <div>{__('IndieButton.line1')}</div>
        <div><strong>{__('IndieButton.line2')}</strong></div>
        <div>{__('IndieButton.line3')}</div>
      </a>
    )
  }
}

export default IndieButton


// WEBPACK FOOTER //
// ./src/components/IndieButton.js